import type { App } from "vue";
import type { AxiosResponse } from "axios";
import axios from "axios";
import VueAxios from "vue-axios";
import { User } from "./auth";

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    // ** const httpsAgent = new https.Agent({
    //  rejectUnauthorized: false,
    // });
    // ApiService.vueInstance.axios.defaults.httpsAgent = httpsAgent;
    // ApiService.vueInstance.axios.defaults.baseURL = "http://localhost:3007/api";
    // ApiService.vueInstance.axios.defaults["updateUrl"] ='http://localhost:3007/';
    // ApiService.vueInstance.axios.defaults.baseURL ='https://back.romastechnologie.com/api';
    // ApiService.vueInstance.axios.defaults.baseURL = 'https://apimairieadjohoun.romastechnologie.com/api';
    // ApiService.vueInstance.axios.defaults["updateUrl"] ='https://apimairieadjohoun.romastechnologie.com/';
    ApiService.vueInstance.axios.defaults.baseURL = 'https://adjohounapi.mairie.bj/api';
    ApiService.vueInstance.axios.defaults["updateUrl"] ='https://adjohounapi.mairie.bj/';
    
    ApiService.vueInstance.axios.defaults.headers.common["Accept"] =
      "application/json";
    ApiService.vueInstance.axios.defaults.headers.common["Content-Type"] =
      "application/json";
    // Le token d'authentification voyage désormais dans un cookie HttpOnly
    // posé par l'API ; le navigateur doit donc envoyer les cookies avec
    // chaque requête cross-origin.
    ApiService.vueInstance.axios.defaults.withCredentials = true;

    // Une réponse 401 signifie que la session (cookie) est absente,
    // invalide ou expirée : on nettoie l'état local et on empêche
    // l'interface protégée de rester affichée sans données.
    // Import dynamique pour éviter un cycle avec auth.ts/router (qui
    // importent tous les deux ApiService).
    ApiService.vueInstance.axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          const [{ useAuthStore }, { default: router }] = await Promise.all([
            import("@/services/auth"),
            import("@/router"),
          ]);
          const authStore = useAuthStore();
          if (authStore.isAuthenticated) {
            authStore.$patch({ isAuthenticated: false, user: {} as any });
          }
          if (router.currentRoute.value.name !== "LoginPage") {
            router.push({ name: "LoginPage" });
          }
        }
        return Promise.reject(error);
      }
    );

    ApiService.vueInstance.use(VueAxios, axios);
  }

  /**
   * @deprecated l'authentification passe désormais par un cookie HttpOnly
   * envoyé automatiquement (voir `withCredentials` dans `init`). Conservé
   * en no-op pour ne pas casser les appelants existants.
   */
  public static setHeader(): void {
    // no-op
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static query(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(resource, params);
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param slug: string
   * @returns Promise<AxiosResponse>
   */
  // public static get(
  //   resource: string,
  //   slug = "" as string
  // ): Promise<AxiosResponse> {
  //   return ApiService.vueInstance.axios.get(`${resource}/${slug}`);
  // }
  public static get(resource: string, config?: any): Promise<AxiosResponse> {
  return ApiService.vueInstance.axios.get(resource, config);
}


  /**
   * @description set the POST HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */

  // public static post(resource: string, params: any): Promise<AxiosResponse> {
  //   return ApiService.vueInstance.axios.post(`${resource}`, params);
  // }

  public static post(resource: string, params: any, config?: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.post(`${resource}`, params, config);
  }


  public static postWithFile(resource: string, params: any): Promise<AxiosResponse> {
    console.log("=== ApiService.postWithFile ===");
    console.log("Resource:", resource);
    console.log("Params type:", typeof params);
    console.log("Is FormData:", params instanceof FormData);
    
    if (params instanceof FormData) {
      console.log("FormData contents in ApiService:");
      for (const [key, value] of params.entries()) {
        console.log(`  ${key}:`, value);
      }
    }
    
    return ApiService.vueInstance.axios.post(`${resource}`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "*/*"
      }
    });
  }

  public static putWithFile(resource: string, params: any): Promise<AxiosResponse> {
  console.log("=== ApiService.putWithFile ===");
  console.log("Resource:", resource);
  console.log("Params type:", typeof params);
  console.log("Is FormData:", params instanceof FormData);
  
  if (params instanceof FormData) {
    console.log("FormData contents in ApiService:");
    for (const [key, value] of params.entries()) {
      console.log(`  ${key}:`, value);
    }
  }
  
  return ApiService.vueInstance.axios.put(`${resource}`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept": "*/*"
    }
  });
}

  /**
   * @description send the UPDATE HTTP request
   * @param resource: string
   * @param slug: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static update(
    resource: string,
    slug: string,
    params: any
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
  }

  /**
   * @description Send the PUT HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  // public static put(resource: string, params: any): Promise<AxiosResponse> {
  //   return ApiService.vueInstance.axios.put(`${resource}`, params);
  // }
  public static put(resource: string, params: any, config?: any): Promise<AxiosResponse> {
  return ApiService.vueInstance.axios.put(`${resource}`, params, config);
}


  /**
   * @description Send the DELETE HTTP request
   * @param resource: string
   * @returns Promise<AxiosResponse>
   */
  public static delete(resource: string): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource);
  }
}

export default ApiService;

